import React from "react";
import { Button, Spinner } from "react-bootstrap";

const LoadingButton = ({ loading, children, disabled, spinnerText = "Procesando...", ...rest }) => {
  return (
    <Button disabled={loading || disabled} {...rest}>
      {loading && (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
      )}
      {loading ? spinnerText : children}
    </Button>
  );
};

export default LoadingButton;